import { MATERIAL_TYPES, TILE_SIZES } from '@mixtiles/web-backend-shared'
import { FALLBACK_NO_MAT_STYLE } from 'pages/PhotoStyler/TileDesignerConsts'
import type { PetAiWallUpsell } from './createPetAiWallUpsell'

export const BATH_TIME: PetAiWallUpsell<'bath-time'> = {
  id: 'bath-time',
  experimentFlag: 'cart-upsell-bath-time-2',
  // The spa pet template AI tile variations generate from; Bath Time asks for four of its style_variants in one job.
  templateSlug: 'spa_pet_six_nb2',
  productFlow: 'BATH_TIME_UPSELL',
  variantIndexes: [1, 0, 2, 5],
  tile: {
    tileSize: TILE_SIZES.SQUARE_8X8,
    materialType: MATERIAL_TYPES.CLASSIC,
    customStyle: FALLBACK_NO_MAT_STYLE,
  },
  cardTitleKeys: {
    dog: 'cart_upsells.bath_time.card_title_dog',
    cat: 'cart_upsells.bath_time.card_title_cat',
  },
  cardCtaKey: 'cart_upsells.bath_time.card_cta',
  flowTitleKey: 'cart_upsells.bath_time.flow_title',
}
